import { Routes } from '@angular/router';
import { LoginFormComponent} from './shared/components';
import { AuthGuardService, NotBaseService, OnlyAdminService, OnlyBaseService } from './shared/services';
import { HomeComponent } from './pages/home/home.component';
import { TabellaDpiComponent } from './pages/tabella-dpi/tabella-dpi.component';
import { NewAllegatoArticoliComponent } from './pages/new-allegato-articoli/new-allegato-articoli.component';
import { MovimentiArticoliComponent } from './pages/magazzino/movimenti-articoli/movimenti-articoli.component';
import { DisplayDataComponent } from './pages/display-data/display-data.component';
import { TipiArticoliComponent } from './pages/tabelle/tipi-articoli/tipi-articoli.component';
import { CausaliMovmagComponent } from './pages/tabelle/causali-movmag/causali-movmag.component';
import { GestioneCopeDpiDettagliComponent } from './pages/gestione-cope-dpi-dettagli/gestione-cope-dpi-dettagli.component';
import { CalcoloRiepilogoRiordinoComponent } from './pages/magazzino/calcolo-riepilogo-riordino/calcolo-riepilogo-riordino.component';
import { GiacenzeComponent } from './pages/magazzino/giacenze/giacenze.component';
import { ImportaDatiDistributoreComponent } from './pages/magazzino/importa-dati-distributore/importa-dati-distributore.component';
import { MovMagComponent } from './pages/magazzino/mov-mag/mov-mag.component';
import { ParametriGraficiComponent } from './pages/parametri/parametri-grafici/parametri-grafici.component';
import { ParametriStampaComponent } from './pages/parametri/parametri-stampa/parametri-stampa.component';
import { ProposteGestioneComponent } from './pages/proposte-gestione/proposte-gestione.component';
import { ArticoliDetailsComponent } from './pages/tabelle/articoli-details/articoli-details.component';
import { ArticoliComponent } from './pages/articoli/articoli/articoli.component';
import { DistributoriComponent } from './pages/tabelle/distributori/distributori.component';
import { MansioniComponent } from './pages/tabelle/mansioni/mansioni.component';
import { ModelliMansioniComponent } from './pages/tabelle/modelli-mansioni/modelli-mansioni.component';
import { RepartiComponent } from './pages/tabelle/reparti/reparti.component';
import { SitiComponent } from './pages/tabelle/siti/siti.component';
import { LogAccessiComponent } from './pages/tabelle/log-accessi/log-accessi.component';
import { CambioPasswordNewComponent } from './pages/utenti/cambio-password-new/cambio-password-new.component';
import { MagazzinoNewMovimentoComponent } from './pages/magazzino/magazzino-new-movimento/magazzino-new-movimento.component';
import { NuovaConsegnaComponent } from './pages/dipendenti/nuova-consegna/nuova-consegna.component';
import { LogAzioniTabellaComponent } from './utils/ildato-log-azioni/components/log-azioni-tabella/log-azioni-tabella.component';
import { ArticoliNewComponent } from './pages/articoli/articoli-new/articoli-new.component';
import { AllegatiGenericiComponent } from './pages/allegati-generici/allegati-generici.component';
import { ArticoliDashboardComponent } from './pages/articoli/articoli-dashboard/articoli-dashboard.component';
import { ArticoliEdtComponent } from './pages/articoli/articoli-edt/articoli-edt.component';
import { ArticoloDetailComponent } from './pages/articolo-detail/articolo-detail.component';
import { ArticoliDipendenteComponent } from './pages/dipendenti/articoli-dipendente/articoli-dipendente.component';
import { DipendentiDashboardComponent } from './pages/dipendenti/dipendenti-dashboard/dipendenti-dashboard.component';
import { DipendentiDetailsComponent } from './pages/dipendenti/dipendenti-details/dipendenti-details.component';
import { DipendentiEdtComponent } from './pages/dipendenti/dipendenti-edt/dipendenti-edt.component';
import { DipendentiImportComponent } from './pages/dipendenti/dipendenti-import/dipendenti-import.component';
import { DipendentiNewComponent } from './pages/dipendenti/dipendenti-new/dipendenti-new.component';
import { DipendentiComponent } from './pages/dipendenti/dipendenti/dipendenti.component';
import { DocMovimentoComponent } from './pages/doc-movimento/doc-movimento.component';
import { LoginEntraIdComponent } from './shared/components/login-entraid/login-entraid.component';
import { UtentiComponent } from './pages/tabelle/utenti/utenti.component';
import { ParametriComponent } from './pages/tabelle/parametri/parametri.component';
import { RestituzioneGuidataComponent } from './pages/procedura-guidata/restituzione-guidata/restituzione-guidata.component';
import { ConsegnaGuidataComponent } from './pages/procedura-guidata/consegna-guidata/consegna-guidata.component';
import { DashboardGuidataComponent } from './pages/procedura-guidata/dashaboard-guidata/dashboard-guidata.component';
import { ArticoliStatisticheComponent } from './pages/articoli/articoli-statistiche/articoli-statistiche.component';

export const routes: Routes = [
 
  {
    path: 'display-data',
    component: DisplayDataComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'propostegestione',
    component: ProposteGestioneComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'tabella-dpi',
    component: TabellaDpiComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/tipologie-articoli',
    component: TipiArticoliComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'articoli',
    component: ArticoliComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'articoli-statistiche',
    component: ArticoliStatisticheComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'articoli/new',
    component: ArticoliNewComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'articoli/:id',
    component: ArticoliDashboardComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'articoli/edt/:id',
    component: ArticoliEdtComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'tabelle/reparti',
    component: RepartiComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/siti',
    component: SitiComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/articoli/detail/:idArticolo',
    component: ArticoliDetailsComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/causali-movimentazione',
    component: CausaliMovmagComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/mansioni',
    component: MansioniComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/modelli-mansioni',
    component: ModelliMansioniComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/distributori',
    component: DistributoriComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/logAccessi',
    component: LogAccessiComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/logAzioni',
    component: LogAzioniTabellaComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/utenti',
    component: UtentiComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'tabelle/parametri',
    component: ParametriComponent,
    canActivate: [OnlyAdminService]
  },
  {
    path: 'gestione-cope-dpi',
    component: GestioneCopeDpiDettagliComponent,
    canActivate: [NotBaseService]
  },

  {
    path: 'magazzino/movimentazioni',
    component: MovMagComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'magazzino/new-movimento',
    component: MagazzinoNewMovimentoComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'importa-dati-distributore',
    component: ImportaDatiDistributoreComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'calcolo-riepilogo-riordino',
    component: CalcoloRiepilogoRiordinoComponent,
    canActivate: [NotBaseService]
  },

  {
    path: 'tabelle/articoli/new-allegato/:idArticolo',
    component: NewAllegatoArticoliComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'movimenti-articoli/:firmati',
    component: MovimentiArticoliComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/consegne-effettuate',
    component: ArticoliDipendenteComponent,
    canActivate: [NotBaseService]
  },

  {
    path: 'dipendenti/nuova-consegna',
    component: NuovaConsegnaComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/nuova-consegna/:idDipendente',
    component: NuovaConsegnaComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'doc-movimento/:progrMov/:consegnaGiornaliera',
    component: DocMovimentoComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti',
    component: DipendentiComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/new',
    component: DipendentiNewComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/:id',
    component: DipendentiDashboardComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/detail/:idDipendente',
    component: DipendentiDetailsComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/edt/:id',
    component: DipendentiEdtComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'dipendenti/detail/:idDipendente/:tab',
    component: DipendentiDetailsComponent,
    canActivate: [NotBaseService]
  },

  {
    path: 'dipendenti/import',
    component: DipendentiImportComponent,
    canActivate: [NotBaseService]
  },

  {
    path: 'dashboard-giornaliera',
    component: DashboardGuidataComponent,
    canActivate: [OnlyBaseService]
  },
  {
    path: 'consegna-giornaliera',
    component: ConsegnaGuidataComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'restituzione-giornaliera',
    component: RestituzioneGuidataComponent,
    canActivate: [AuthGuardService]
  },

  {
    path: 'magazzino/giacenze',
    component: GiacenzeComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'parametri/grafici',
    component: ParametriGraficiComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'parametri/stampa',
    component: ParametriStampaComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'utenti/cambio-password',
    component: CambioPasswordNewComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'articolo/detail/:idArticolo',
    component: ArticoloDetailComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'allegati-generici',
    component: AllegatiGenericiComponent,
    canActivate: [NotBaseService]
  },
  {
    path: 'login-form',
    component: LoginFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'login-entraid',
    component: LoginEntraIdComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: '**',
    redirectTo: 'home'
  }
  
];